import _ from "lodash";

import template from "./index.html";
import repeatController from "../../../../../ui-formly/types/repeater/controller";

function formlyLocations() {
  var formly = {
    key: "Locations",
    name: "Locations",
    data: {
      totalQuantity: 0,
      onModelChange: modelChange,
    },
    controller: repeatController,
    templateUrl: template,
    templateOptions: {
      fields: [
        {
          key: "PartPropertyId",
          name: "PartPropertyId",
          type: "readonly",
          className: "col-xs-1",
        },
        {
          //NB not traversing to the levels i.e PartProperty.Name is not working 
          key: "PartPropertyName",
          name: "PartPropertyName",
          type: "readonly",
          className: "col-xs-2",
        },
        {
          key: "Shelf",
          name: "Shelf",
          type: "readonly",
          className: "col-xs-1",
        },
        {
          key: "Bin",
          name: "Bin",
          type: "readonly",
          className: "col-xs-1",
        },
        {
          key: "Quantity",
          name: "Quantity",
          type: "readonly",
          className: "col-xs-2",
        },
        {
          key: "Retire",
          name: "Retire",
          type: "gridInput",
          modelOptions: {
            debounce: {
              default: 500,
              blur: 0,
            },
          },
          templateOptions: {
            required: true,
            label: "Retire Quantity",
            type: "number",
            min: 0,
            default:0
          },
          expressionProperties: {
            'templateOptions.max': 'model.Quantity'
          },
          className: "col-xs-4",
        },
      ],
    },
  };

  return [formly];
}

function modelChange(newLocations, oldLocations, $scope) {
  var totalQuantity = getTotalQuantity(newLocations);
  $scope.options.data.totalQuantity = totalQuantity;
}

function getTotalQuantity(locations) {
  var count = locations ? locations.length : 0;
  if (count > 0) {
    var totalQuantity = _.reduce(
      locations,
      function (sum, location) {
        return sum + location.Quantity;
      },
      0
    );
    return totalQuantity;
  }

  return 0;
}



export default formlyLocations;
